import type { NetworkCasseDetail, NetworkCasseDetailSelectionParams } from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchNetworkCasseDetail } from '../queries/networkCasseDetail.queries'

export const useNetworkCasseDetail = (
  selection: NetworkCasseDetailSelectionParams,
  enabled = true,
): UseQueryResult<NetworkCasseDetail, unknown> =>
  useQuery({
    queryKey: [
      'get-network-casse-detail',
      selection.storeIds,
      selection.storeAgeFilter,
      selection.ageStoreIds,
      selection.comparableStoreIds,
      selection.categoryIds,
      selection.startDate,
      selection.endDate,
      selection.comparableStartDate,
      selection.comparableEndDate,
    ],
    queryFn: () => fetchNetworkCasseDetail(selection),
    placeholderData: keepPreviousData,
    enabled,
  })
